import {
  requestShopList,
  requestShopDetail,
  requestObituaryShopInfo,
  requestShopPayParamRegist,
  requestGetShopOrderInfo,
  requestConfirmToss,
} from "@/apis/shop_api";

const state = {
  shopList: [],

  shopDetail: {
    id: null,
    price: 0
  },

  shopObituaryDetail: {},

  shopOrderInfo: null
};

const getters = {
  getShopList: state => state.shopList,
  getShopDetail: state => state.shopDetail,
  getShopObituaryDetail: state => state.shopObituaryDetail,
  getShopOrderInfo: state => state.shopOrderInfo
};

const mutations = {
  SHOP_LIST(state, data) {
    state.shopList = data.resultShopList;
  },

  SHOP_DETAIL(state, data) {
    state.shopDetail = data.resultShop;
  },

  SHOP_OBITUARY_DETAIL(state, data) {
    state.shopObituaryDetail = data.obituaryDetail;
  },

  SET_SHOP_ORDER_INFO(state, data) {
    state.shopOrderInfo = data.shopOrderInfo;
  },

  INIT_SHOP_LIST(state) {
    state.shopList = [];
  },

  INIT_SHOP_DETAIL(state) {
    state.shopDetail = {
      id: null,
      price: 0
    };

    state.obituaryDetail = {};
  }
};

const actions = {
  async REQUEST_SHOP_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");

      const response = await requestShopList(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SHOP_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert("Shop 조회에 실패하였습니다.");
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_SHOP_DETAIL({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestShopDetail(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SHOP_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      alert("Shop 조회에 실패하였습니다.");
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_OBITUARY_SHOP_INFO({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryShopInfo(parameter.EcodeId);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SHOP_OBITUARY_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert("Shop 조회에 실패하였습니다.");
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_SHOP_PAY_PARAM_REGIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestShopPayParamRegist(parameter);
      const { data } = response;

      return data;
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert("Shop 결제 정보 등록에 실패하였습니다");
      console.error(e);
      return {
        result: "fail"
      };
    } finally {
      commit("END_LOADING");
    }
  },

  // 상품 주문서 조회
  async REQUEST_GET_SHOP_ORDER_INFO({ commit }, params) {
    try {
      const response = await requestGetShopOrderInfo(params);
      const { data } = response;

      if (data) {
        commit("SET_SHOP_ORDER_INFO", data);

        return data;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  // 토스결제 컨펌
  async REQUEST_CONFIRM_TOSS({ commit }, params) {
    try {
      const res = await requestConfirmToss(params);
      const {data} = res;
      if (data?.orderInfo) {
        commit("SET_SHOP_ORDER_INFO", data.orderInfo);
      }
      return data;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
};

export default { mutations, state, actions, getters };
